var _mask, _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 420,
    height: 300,
    fill: "none",
    viewBox: "0 0 420 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_209_20",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M319.761 300L150.358 300C67.3176 300 0 232.843 0 150C0 67.1573 67.3176 0 150.358 0C217.131 0 273.738 43.4226 293.354 103.507C301.767 101.22 310.622 100 319.761 100C375.122 100 420 144.772 420 200C420 255.228 375.122 300 319.761 300Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_209_20)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_209_20)",
    fillRule: "evenodd",
    d: "M319.761 300L150.358 300C67.3176 300 0 232.843 0 150C0 67.1573 67.3176 0 150.358 0C217.131 0 273.738 43.4226 293.354 103.507C301.767 101.22 310.622 100 319.761 100C375.122 100 420 144.772 420 200C420 255.228 375.122 300 319.761 300Z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.05,
    d: "M150.358 300L150.358 299H150.358V300ZM319.761 300L319.761 301L319.761 301L319.761 300ZM293.354 103.507L292.403 103.817L292.698 104.721L293.616 104.472L293.354 103.507ZM150.358 301L319.761 301L319.761 299L150.358 299L150.358 301ZM-1 150C-1 233.397 66.7675 301 150.358 301V299C67.8676 299 1 232.288 1 150H-1ZM150.358 -1C66.7675 -1 -1 66.6027 -1 150H1C1 67.7118 67.8676 1 150.358 1V-1ZM294.304 103.196C274.558 42.7118 217.575 -1 150.358 -1V1C216.687 1 272.918 44.1334 292.403 103.817L294.304 103.196ZM293.616 104.472C301.945 102.208 310.711 101 319.761 101V99C310.532 99 301.59 100.232 293.091 102.542L293.616 104.472ZM319.761 101C374.572 101 419 145.326 419 200H421C421 144.217 375.672 99 319.761 99V101ZM419 200C419 254.674 374.572 299 319.761 299L319.761 301C375.672 301 421 255.783 421 200H419Z",
    mask: "url(#path-1-inside-1_209_20)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_209_20",
    width: 420,
    height: 348.647,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 48.647
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "normal",
    result: "effect1_innerShadow_209_20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_209_20",
    x1: 29.423,
    x2: 419.459,
    y1: 0,
    y2: 300.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C1C1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.694c2d34cec598a606d08f10bcbedf15.svg";
export { ForwardRef as ReactComponent };